export default __webpack_public_path__ + "static/up_down_b.8300bf29d9ac8f2ed1a3e0618010e558.png";